import React from 'react';

import { Icon } from 'components';
import FixtureData from '../../FixtureData';
import useFixtureDataFootball from './useFixtureDataFootball';

import varIcon from 'assets/svg/var-icon.svg';
import './fixtureDataFootball.scss';

interface Props {
    matchId: string;
    firstIcon: JSX.Element | null;
    secondIcon: JSX.Element | null;
    text: string | null;
    subText: string | null;
}

const FixtureDataFootball: React.FC<Props> = ({
    firstIcon,
    secondIcon,
    text,
    subText,
    matchId,
}) => {
    const {
        isVar,
        text: footballText,
        subText: footballSubtext,
    } = useFixtureDataFootball({ matchId, text, subText });

    return (
        <FixtureData
            firstIcon={firstIcon}
            secondIcon={secondIcon}
            text={footballText}
            subText={footballSubtext}
            thirdIcon={isVar ? <Icon glyph={varIcon} styleName="var" /> : null}
        />
    );
};

export default FixtureDataFootball;
